// During development, import from source CSS
// During build, this will be transformed to the compiled CSS
import tailwindCSS from './globals.css?inline'

// Transform :root to :host for Shadow DOM compatibility
const transformedCSS = tailwindCSS.replace(/:root/g, ':host')

export const tailwindStyles = transformedCSS